import {
  CURRENCY_MAPPER,
  formatCommerceDiscountBadge,
  formatCommercePrize,
  formatNumberToPrice,
} from '../../PriceHelpers';

const getCartLineId = (serviceOption, childProducts = []) => {
  const service = childProducts.find((item) => item.variantId === serviceOption.variantId);
  return service && service.cartLineId;
};

const mapWarrantyOptions = (warranty, childProducts, tenant, textDictionary, toggles) => {
  const options = warranty?.fieldOptions ?? [];
  const extendedWarrantyLink = warranty?.extendedWarrantyLink ?? '';
  if (options.length === 0) {
    return undefined;
  }

  let cartLineId = '';
  const mappedFieldOptions = options.map((option) => {
    const id = getCartLineId(option, childProducts);
    if (id) {
      cartLineId = id;
    }
    const { label, discountBadge, selected, prices, price } = option;
    const textPrice = label
      ? `${CURRENCY_MAPPER[option?.price?.currency] || ''} ${formatNumberToPrice(price.centAmount / price.fraction)}`
      : '';
    return {
      ...option,
      label: label ? `${label} ${textPrice}` : 'No, gracias',
      textPrice,
      prices: prices?.length > 0 ? formatCommercePrize(prices, tenant, textDictionary, toggles) : undefined,
      discountBadge: discountBadge ? formatCommerceDiscountBadge(discountBadge) : undefined,
      textLabel: label || 'No, gracias',
      selected,
    };
  });

  return {
    defaultText: 'No, gracias',
    fieldName: 'Warranty',
    fieldType: 3,
    label: 'Garantía Extendida',
    fieldOptions: mappedFieldOptions,
    extendedWarrantyLink,
    cartLineId,
  };
};

const mapAssemblyOptions = (serviceOptions, childProducts, tenant, textDictionary, toggles) => {
  const options = serviceOptions?.fieldOptions ?? [];

  if (options.length === 0) {
    return undefined;
  }

  const mappedFieldOptions = options
    .filter((option) => option.label)
    .map((option) => {
      let cartLineId = '';
      const id = getCartLineId(option, childProducts);
      if (id) {
        cartLineId = id;
      }
      const { label, prices, discountBadge, price } = option;
      const textPrice = label
        ? `${CURRENCY_MAPPER[option?.price?.currency] || ''} ${formatNumberToPrice(price.centAmount / price.fraction)}`
        : '';
      const mappedOption = {
        ...option,
        textLabel: label,
        textPrice,
        prices: prices?.length > 0 ? formatCommercePrize(prices, tenant, textDictionary, toggles) : undefined,
        discountBadge: discountBadge ? formatCommerceDiscountBadge(discountBadge) : undefined,
        label: `${label} ${textPrice}`,
      };
      if (label) {
        mappedOption.cartLineId = cartLineId;
      }
      return mappedOption;
    });

  return {
    defaultText: 'No, gracias',
    fieldName: '2',
    label: 'Selecciona servicios adicionales',
    fieldOptions: mappedFieldOptions,
  };
};

export const mapProduct = (item, tenant, textDictionary, toggles) => {
  const {
    brandName,
    imageUrl,
    name,
    prices,
    productId,
    variantId,
    quantity: qty,
    pdpUrl: link,
    warrantyOptions: warranty,
    serviceOptions,
    cartLineId,
    childProducts,
    offeringId,
    qtyLimits,
  } = item;

  return {
    brandName,
    image: imageUrl,
    name,
    price: formatCommercePrize(prices, tenant, textDictionary, toggles),
    productId,
    skuId: variantId,
    quantity: Number(qty.quantityNumber),
    url: link,
    warrantyOptions: mapWarrantyOptions(warranty, childProducts, tenant, textDictionary, toggles),
    assemblyOptions: mapAssemblyOptions(serviceOptions, childProducts, tenant, textDictionary, toggles),
    totalQuantity: Number(qty.quantityNumber),
    commerceItemId: '',
    cartLineId,
    childProducts,
    offeringId,
    qtyLimits,
  };
};
